import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ListLinkBox from '../../../../components/UI/ListLinkBox';
import BackButton from '../../../../components/UI/BackButton';
import * as actionInventory from '../../../../actions/inventoryAction';
import { checkPermission, getVision } from '../../../../services/auth';
import { PERMISSIONS, VISIONS } from '../../../../utils/constants';
import { downloadFile, translate } from '../../../../utils/util';
import InventoryService from '../../../../services/InventoryService';

const GeneralInventoryFilter = (props) => {
    const menu = () => {

        let menuItems = [];
        menuItems = [...menuItems, {
            route: {
                pathname: 'filter/advanced',
                state: {
                    secondCount: false
                }
            }, icon: 'mdi mdi-filter-variant', text: translate('general.filterAdvanced', 'inventory')
        }];

        menuItems = [...menuItems, {
            route: {
                pathname: 'lots',
                state: {
                    secondCount: false
                }
            }, icon: 'view_list', text: translate('general.all', 'inventory')
        }];

        menuItems = [...menuItems, {
            route: {
                pathname: 'filter/zone',
                state: {
                    secondCount: false
                }
            }, icon: 'mdi mdi-map-marker-radius-outline', text: translate('general.zone', 'inventory')
        }];

        menuItems = [...menuItems, {
            route: {
                pathname: 'filter/partnumber',
                state: {
                    secondCount: false
                }
            }, icon: 'layers', text: translate('general.partnumber', 'inventory')
        }];

        menuItems = [...menuItems, {
            route: {
                pathname: 'filter/lot',
                state: {
                    secondCount: false
                }
            }, icon: 'mdi mdi-clipboard-list-outline', text: translate('general.lot', 'inventory')
        }];

        if (checkPermission(PERMISSIONS.Inventory.General.Supervisor) || checkPermission(PERMISSIONS.Inventory.Rotative.Supervisor)) {
            menuItems = [...menuItems, {
                route: {
                    pathname: 'filter/lotItem',
                    state: {
                        secondCount: false
                    }
                }, icon: 'mdi mdi-text-box-check-outline', text: translate('general.menu.lotItem', 'inventory')
            }];
        }

        menuItems = [...menuItems, {
            route: {
                pathname: 'filter/cim',
                state: {
                    secondCount: false
                }
            }, icon: 'filter_center_focus', text: translate('general.cim', 'inventory')
        }];

        if (getVision() === VISIONS.Jeep) {
            menuItems = [...menuItems,
            {
                route: {
                    pathname: 'filter/advanced',
                    state: {
                        secondCount: true
                    }
                },
                icon: 'mdi mdi-numeric-2-box-outline',
                text: translate('general.secondCount', 'inventory')
            }];

            menuItems = [...menuItems, {
                icon: 'mdi mdi-clipboard-list-outline',
                text: "Relatório Segunda Contagem",
                route: 'filter',
                onClick: () => {
                    props.getReport({
                        inventoryCode: props.inventory.code || "",
                        secondCount: true
                    }, (data) => {
                        downloadFile(data, `ReportInventory${Date.now()}.csv`, "data:text/csv", false);
                    });
                }
            }];
        }

        return menuItems;
    }

    useEffect(() => {
        props.resetFilters();
        // eslint-disable-next-line
    }, []);

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <div className="title">
                        <i className="mdi mdi-clipboard-check-outline" />
                        {translate('inventory', 'inventory')}
                    </div>
                    <div className="subtitle">
                        | <i className="mdi mdi-alpha-g-circle-outline" />
                        {props.filter.typeInventory === 'G' ? translate('menu.general', 'inventory') : translate('menu.rotative', 'inventory')}
                    </div>
                    <div className="subtitle">
                        | <i className="material-icons">filter_list</i>
                        {translate('general.filter', 'inventory')}
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginLeft: '5px', marginTop: '40px', }}>
                <ListLinkBox options={menu()} />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        filter: state.inventoryReducer.filter,
        inventory: state.inventoryReducer.inventory
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getReport: (filter, callback) => {
            dispatch(InventoryService.getReport(filter, callback));
        },
        resetFilters: () => {
            dispatch(actionInventory.resetFilters());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GeneralInventoryFilter)));